import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  formLoading: false,
  formError: null,
  loadedActivity: null,
  parentEntities: [],
  formSubmitSuccess: false,
  sourceCategories: [],
  categorySources: [],
  sourceData: {},
  activities: {
    loading: false,
    error: null,
    data: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
  },
};

export const entitySlice = createSlice({
  name: 'activity',
  initialState,
  reducers: {
    createActivityRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    createActivitySuccess: (state, {payload}) => {
      state.formLoading = false;
      state.loadedActivity = payload;
      state.formSubmitSuccess = true;
    },
    createActivityError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    fetchEntitiesRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    fetchEntitiesSuccess: (state, {payload}) => {
      state.formLoading = false;
      state.parentEntities = payload;
    },
    fetchEntitiesError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
      state.parentEntities = [];
    },
    resetFormSubmitSuccess: (state, {payload}) => {
      state.formSubmitSuccess = payload;
    },
    fetchActivityRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    fetchActivitySuccess: (state, {payload}) => {
      state.formLoading = false;
      state.loadedActivity = payload;
    },
    fetchActivityError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
      state.loadedActivity = null;
    },

    updateActivityRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    updateActivitySuccess: (state, {payload}) => {
      state.formLoading = false;
      state.loadedActivity = payload;
      state.formSubmitSuccess = true;
    },
    updateActivityError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },

    fetchSourceCategoriesRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    fetchSourceCategoriesSuccess: (state, {payload}) => {
      state.formLoading = false;
      state.sourceCategories = payload;
    },
    fetchSourceCategoriesError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
      state.sourceCategories = [];
    },
    fetchCategorySourcesRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    fetchCategorySourcesSuccess: (state, {payload}) => {
      state.formLoading = false;
      state.categorySources = payload;
    },
    fetchCategorySourcesError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
      state.categorySources = [];
    },

    fetchSourceDataRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    fetchSourceDataSuccess: (state, {payload}) => {
      state.formLoading = false;
      state.sourceData = payload;
    },
    fetchSourceDataError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
      state.sourceData = {};
    },
    resetSourceData: (state) => {
      state.sourceData = {};
    },
    fetchActivitiesRequest: (state) => {
      state.activities.loading = true;
      state.activities.error = null;
    },
    fetchActivitiesSuccess: (state, {payload}) => {
      const {data, page, pageSize, totalPages, totalRecords, sortOn, sortDir} =
        payload;
      state.activities.loading = false;
      state.activities.data = data;
      state.activities.page = page;
      state.activities.pageSize = pageSize;
      state.activities.totalPages = totalPages;
      state.activities.totalCount = totalRecords;
      state.activities.sortOn = sortOn;
      state.activities.sortDir = sortDir;
    },
    fetchActivitiesError: (state, {payload}) => {
      state.activities.loading = false;
      state.activities.error = payload;
    },
  },
});

export const {
  createActivityRequest,
  createActivitySuccess,
  createActivityError,
  fetchEntitiesRequest,
  fetchEntitiesSuccess,
  fetchEntitiesError,
  resetFormSubmitSuccess,
  fetchActivityRequest,
  fetchActivitySuccess,
  fetchActivityError,
  updateActivityRequest,
  updateActivitySuccess,
  updateActivityError,
  fetchSourceCategoriesRequest,
  fetchSourceCategoriesSuccess,
  fetchSourceCategoriesError,
  fetchCategorySourcesRequest,
  fetchCategorySourcesSuccess,
  fetchCategorySourcesError,
  fetchSourceDataRequest,
  fetchSourceDataSuccess,
  fetchSourceDataError,
  resetSourceData,
  fetchActivitiesRequest,
  fetchActivitiesSuccess,
  fetchActivitiesError,
} = entitySlice.actions;

export default entitySlice.reducer;
